import {HttpClient} from "@angular/common/http";
import {FileSaverService} from "ngx-filesaver";
import {environment} from "../../../environments/environment";
import {getFileNameFromHttpResponse} from "../common-functions";
import {Observable} from "rxjs";
import {InternalDocument} from "../components/internal-documents/internal-documents.component";

export class DocumentsEndpoints {

	constructor(private http: HttpClient, private fileSaver: FileSaverService) {
	}

	downloadTermsAndConditions(correlationId: string): void {
		const url: string = `${environment.apiUrl}/order/${correlationId}/document?documentType=TERMS_AND_CONDITIONS`;
		this.http.get(url, {responseType: 'blob' as 'blob', observe: "response"}).subscribe(response => {
			this.fileSaver.save(response.body, getFileNameFromHttpResponse(response));
		});
	}

	downloadOrderPdf(correlationId: string) {
		const url: string = `${environment.apiUrl}/order/${correlationId}/offer-pdf`;
		this.http.get(url, {responseType: 'blob' as 'blob', observe: "response"}).subscribe(response => {
			this.fileSaver.save(response.body, getFileNameFromHttpResponse(response));
		});
	}

	downloadCertificate(correlationId: string, fileUuid: string) {
		const url: string = `${environment.apiUrl}/order/${correlationId}/document?documentType=CURRENT_CERTIFICATE&fileUuid=${fileUuid}`;
		this.http.get(url, {responseType: 'blob' as 'blob', observe: "response"}).subscribe(response => {
			this.fileSaver.save(response.body, getFileNameFromHttpResponse(response));
		});

	}

	downloadReport(correlationId: string, fileUuid: string) {
		const url: string = `${environment.apiUrl}/order/${correlationId}/document?documentType=CURRENT_REPORT&fileUuid=${fileUuid}`;
		this.http.get(url, {responseType: 'blob' as 'blob', observe: "response"}).subscribe(response => {
			this.fileSaver.save(response.body, getFileNameFromHttpResponse(response));
		});
	}

	downloadInternalDocument(correlationId: string, fileUuid: string) {
		const url: string = `${environment.apiUrl}/internal-documents/${correlationId}/document/${fileUuid}`;
		this.http.get(url, {responseType: 'blob' as 'blob', observe: "response"}).subscribe(response => {
			this.fileSaver.save(response.body, getFileNameFromHttpResponse(response));
		});
	}

	downloadInternalDocumentAsText(correlationId: string, fileUuid: string): Observable<string> {
		const url: string = `${environment.apiUrl}/internal-documents/${correlationId}/document/${fileUuid}`;
		return this.http.get(url, {responseType: 'text', observe: "body"});
	}

	getInternalDocumentsMetadata(correlationId: string): Observable<InternalDocument[]> {
		const url: string = `${environment.apiUrl}/internal-documents/${correlationId}`;
		return this.http.get<InternalDocument[]>(url, {
			responseType: "json",
			headers: {'Content-Type': 'application/json;charset=UTF-8'}
		});
	}

	uploadInternalDocument(correlationId: string, file: File): Observable<InternalDocument[]> {
		const url: string = `${environment.apiUrl}/internal-documents/${correlationId}/upload`;
		const formData = new FormData();
		formData.append('file', file);
		return this.http.post<InternalDocument[]>(url, formData);
	}

	deleteInternalDocument(correlationId: string, fileUuid: string): Observable<InternalDocument[]> {
		const url: string = `${environment.apiUrl}/internal-documents/${correlationId}/document/${fileUuid}`;
		return this.http.delete<InternalDocument[]>(url);
	}
}
